import { QACaseStatus, QACaseType } from '../../common/interfaces/IQaCase';

/**
 * place for maintaining all api endpoints
 */
const apiEndPoints = {
  ppwb: 'ppwb',
};

export const getPolicyEndPoint = (policyId: string): string => {
  return `${apiEndPoints.ppwb}/policy/${policyId}`;
};

export const getCarrierPolicyNumbersToPolicyIdsEndPoint = (): string => {
  return `${apiEndPoints.ppwb}/policy/convertCarrierPolicyNumbersToPolicyIds`;
};

export const getPolicyRuleResultEndPoint = (
  policyId: string,
  decisionId: string,
): string => {
  return `${apiEndPoints.ppwb}/tracemap/${policyId}/${decisionId}`;
};

export const getPolicyRuleRawResultEndPoint = (
  policyId: string,
  decisionId: number,
): string => {
  return `${apiEndPoints.ppwb}/tracemap/${policyId}/${decisionId}/raw`;
};

export const getPolicyEvidenceEndPoint = (
  product: string,
  carrier: string,
  policyId: string,
  evidenceId: string,
  type: string,
) => {
  return `${apiEndPoints.ppwb}/evidence/${product}/${carrier}/${policyId}/${evidenceId}/${type}`;
};

export const getPolicyDecisionEndPoint = (
  product: string,
  carrier: string,
  policyId: string,
) => {
  return `${apiEndPoints.ppwb}/decision/${carrier}/${product}/${policyId}`;
};

export const getPolicyDecisionExplanationEndPoint = (
  product: string,
  carrier: string,
  policyId: string,
) => {
  return `${apiEndPoints.ppwb}/decision/${carrier}/${product}/${policyId}/explanation`;
};

export const getPolicyEvidenceListEndPoint = (
  product: string,
  carrier: string,
  policyId: string,
  all: boolean = false,
) => {
  return `${apiEndPoints.ppwb}/evidences/${carrier}/${product}/${policyId}?all=${all}`;
};
export const getMibCodebackDataByPolicyId = (policyId: string) => {
  return `${apiEndPoints.ppwb}/mibCodeback/${policyId}`;
};

export const initiateReconsiderationEndPoint = (
  carrier: string,
  product: string,
  policyId: number,
): string => {
  return `${apiEndPoints.ppwb}/action/${carrier}/${product}/${policyId}/reconsideration`;
};

export const updateHipaaRevocationEndPoint = (policyId: number): string => {
  return `${apiEndPoints.ppwb}/policy/${policyId}/hipaaRevocation`;
};

export const getReconsiderationStatusEndPoint = (
  carrier: string,
  product: string,
  policyId: number,
): string => {
  return `${apiEndPoints.ppwb}/action/${carrier}/${product}/${policyId}/reconsideration`;
};

export const getExistingPoliciesEndPoint = (policyId: string): string => {
  return `${apiEndPoints.ppwb}/policy/${policyId}/existing-policies`;
};

export const getQACasesEndPoint = (params: {
  page: number;
  limit: number;
  status?: QACaseStatus;
  assignedTo?: number;
  caseType?: QACaseType;
  policyId?: number;
  product?: string;
}): string => {
  const { page, limit, status, assignedTo, caseType, policyId, product } =
    params;
  const queryParams: Record<string, string> = {
    page: page.toString(),
    limit: limit.toString(),
  };

  if (status) {
    queryParams.status = status;
  }
  if (assignedTo) {
    queryParams.assignedTo = assignedTo.toString();
  }
  if (caseType) {
    queryParams.caseType = caseType;
  }
  if (policyId) {
    queryParams.policyId = policyId.toString();
  }
  if (product) {
    queryParams.product = product;
  }

  const queryString = Object.entries(queryParams)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  return `${apiEndPoints.ppwb}/qa/cases?${queryString}`;
};

export const updateQACaseEndPoint = (id: number): string => {
  return `${apiEndPoints.ppwb}/qa/cases/${id}`;
};

export const createQACaseEndPoint = (): string => {
  return `${apiEndPoints.ppwb}/qa/cases`;
};

export const bulkCreateQACasesEndPoint = (): string => {
  return `/${apiEndPoints.ppwb}/qa/cases/bulk`;
};

export const assignNextQACaseEndPoint = (): string => {
  return `${apiEndPoints.ppwb}/qa/cases/assign-next`;
};

export const getTaxonomyOptionsEndPoint = (): string => {
  return `${apiEndPoints.ppwb}/qa/taxonomy`;
};

export const getWorkbenchMigrationStatusEndPoint = (
  policyId: number,
): string => {
  return `${apiEndPoints.ppwb}/policy/${policyId}/workbench-migration-status`;
};

export const migrateToWorkbenchEndPoint = (): string => {
  return `${apiEndPoints.ppwb}/policy/migrate-to-workbench`;
};
